


































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class ChatMessageBox extends Vue {
	@Prop({ default: true })
	reversed!: boolean;
	@Prop({ type: String, default: "Anonymus" })
	userName!: string;
	@Prop({ type: String })
	avatar!: string;
	@Prop({ type: String, required: true })
	message!: string;
	@Prop({ type: String, required: true })
	chatTime!: string;

	created() {
		console.log(
			"SHOW THIS: ",
			this.avatar,
			this.userName,
			this.reversed,
			this.message,
			this.chatTime
		);
	}
}
